const rootRoutes = {
  admin: '/admin',
  artists: '/artists',
  events: '/events'
};

export const routeIds = {
  createArtist: 'create-artist',
  createEvent: 'create-event'
};

const resourceRoute = (resource) => (id) => `${resource}/${id === undefined ? ':id' : id}`;

const routes = {
  root: '/',
  home: '/',
  login: '/login',
  newPassword: '/new-password',
  artists: rootRoutes.artists,
  artist: resourceRoute(rootRoutes.artists),
  events: rootRoutes.events,
  event: resourceRoute(rootRoutes.events),
  about: '/about',
  contact: '/contact',
  adminPortal: {
    root: rootRoutes.admin,
    artists: `${rootRoutes.admin}${rootRoutes.artists}`,
    artist: resourceRoute(`${rootRoutes.admin}${rootRoutes.artists}`),
    createArtist: resourceRoute(`${rootRoutes.admin}${rootRoutes.artists}`)(routeIds.createArtist),
    events: `${rootRoutes.admin}${rootRoutes.events}`,
    event: resourceRoute(`${rootRoutes.admin}${rootRoutes.events}`),
    createEvent: resourceRoute(`${rootRoutes.admin}${rootRoutes.events}`)(routeIds.createEvent)
  },
  notFound: '/not-found'
};

export default routes;



// WEBPACK FOOTER //
// ./src/constants/routes.js